export const REPLAY = {
  eyebrow: "YOUR REPLAY IS READY — WATCH THE FULL TRAINING BELOW",
  h1a: "KNOW EXACTLY WHERE YOU STAND",
  h1b: "ON YOUR VA LOAN BENEFIT",
  h1c: "— FROM SOMEONE WHO'S WALKED THE SAME PATH",
  sub: "Watch the full review below, then book your free 1:1 Boots-First VA Benefit Review with Annette — no cost to attend, no pressure.",
  blockquote: "What if the VA guarantees your loan — but nobody ever explained what that does and doesn't cover?",
  availability: "⏳ Your replay is ready — watch anytime, on your schedule.",
  videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  videoTitle: "BOOTS-FIRST VA BENEFIT REVIEW — FULL TRAINING REPLAY",
};

export const REPLAY_TICKER = [
  "45-MINUTE TRAINING",
  "THE BOOTS-FIRST BENEFIT REVIEW",
  "FREE 1:1 FOLLOW-UP",
  "GA · FL · NC · TN COVERAGE",
  "NO COST TO ATTEND",
  "VETERAN-TO-VETERAN",
];

export const RECAP_LINES = [
  { text: "THE VA GUARANTEES", cls: "text-[#F0ECE4]" },
  { text: "YOUR LOAN.", cls: "text-white/[0.28]" },
  { text: "IT DOESN'T GUARANTEE", cls: "text-[#F0ECE4]" },
  { text: "YOU UNDERSTAND YOUR FILE.", cls: "text-[#D9622B]" },
];

export const RECAP_PARA = "You just watched the two myths that stall most veteran homebuyers: the belief that \u201Czero down\u201D means zero funds needed, and the fear that your credit or DTI disqualifies you before anyone's even looked. The Boots-First Benefit Review is where we replace both with your actual numbers — your eligibility, your real reserve picture, and a same-day credit & DTI snapshot. No outcomes promised, no application required. Just clarity, veteran to veteran, so your next move is an informed one.";

export const REVIEW_STEPS = [
  { num: "01", name: "ELIGIBILITY REVIEW", desc: "Know exactly what the VA guarantees and what your lender separately requires." },
  { num: "02", name: "RESERVE & DTI CLARITY", desc: "See your real reserve picture (3-5% of loan amount) and a same-day credit & debt-to-income snapshot." },
  { num: "03", name: "YOUR NEXT STEP", desc: "A judgment-free plan, whether you're ready now or 60+ days out." },
];

export const OFFER_STACK = [
  "1:1 Boots-First VA Benefit & Eligibility Review",
  "Reserve & Closing Cost Clarity Walkthrough",
  "Pre-Application Credit & DTI Snapshot",
  "Veteran-to-Veteran Direct Access Line",
  "A Follow-Up Plan Built Around Your Timeline",
];

export const GUARANTEE = {
  title: "THE BOOTS-FIRST PROMISE",
  body: "If you complete the intake, attend your review, and I determine you don't currently qualify, I'll tell you exactly why and build a specific plan with you to get there — at no charge, and with no pressure to apply until you're ready.",
  smallPrint: "Service guarantee only. Not a guarantee of loan approval, rate, or closing.",
};

export const REPLAY_BIO = [
  "Before I was a loan officer, I was a soldier. I served in the U.S. Army, and when it came time to use my own VA loan benefit, nobody walked me through it. I learned what the guarantee actually covered — and what it didn't — the hard way, one surprise at a time.",
  "That experience is the entire reason the Boots-First Benefit Review exists. I built it as the sit-down I wish someone had given me: eligibility explained plainly, the real reserve picture on the table, and a same-day read on credit and DTI before any application is ever filled out.",
  "When we meet, you're not talking to a salesperson working a script. You're talking to a veteran who's been on your side of the desk — and who will tell you the honest answer, even when that answer is \u201Cnot yet, and here's the plan to get there.\u201D",
];

export const OBJECTIONS = {
  heading: "STILL ON THE FENCE?",
  paras: [
    "Maybe you've been burned before — a lender who'd never served, tossing acronyms at you and rushing you toward an application. That's not this. I wore the uniform, I used this benefit myself, and the review is built around your questions, not my pipeline.",
    "Or maybe you're thinking \u201CI'm not ready yet.\u201D That's exactly who this is for. If the honest answer is \u201Cnot yet,\u201D you'll leave with a written, specific plan for getting there — and zero pressure to apply until the timing is yours.",
  ],
  bullets: [
    "We go through your eligibility and reserve picture together, live",
    "You get a same-day Credit & DTI Snapshot",
    "You leave with a written next step, whether the timing is now or later",
  ],
};

export const REPLAY_FAQS = [
  { q: "Is the 1:1 review really free?", a: "Yes — completely free. The Boots-First VA Benefit Review is an educational session. There's nothing to buy, no fee, and no obligation to move forward with anything afterward." },
  { q: "Is this a loan application?", a: "No. The review is educational only — it is not a loan application, a pre-approval, or a commitment to lend. Nothing is submitted to underwriting, and no outcome is promised or guaranteed." },
  { q: "What if the honest answer is \u201Cnot yet\u201D?", a: "Then you'll hear exactly that — along with the specific reasons why and a written plan to get there. That's the Boots-First Promise: a straight answer and a path forward, at no charge and with no pressure." },
  { q: "Do I have to use Annette for my loan?", a: "No. The review carries zero obligation. You're free to take everything you learn and work with any lender you choose. The goal is that you make your next move fully informed." },
  { q: "What if I'm not buying for another 60+ days?", a: "Perfect timing, actually. The further out you are, the more room there is to line up reserves, credit, and documentation calmly. Your follow-up plan is built around your timeline — not a generic drip." },
  { q: "How long is the replay available?", a: "Your replay doesn't expire — watch it anytime, on your schedule. That said, the sooner you know where you stand, the more options you have when you're ready to move." },
  { q: "What happens after I book?", a: "You'll get a confirmation with your session details. At the review, we walk through your eligibility, your real reserve picture, and a same-day credit & DTI snapshot — then you leave with a written next step. No credit is pulled unless you separately and expressly authorize it." },
  { q: "What states does Annette serve?", a: "Georgia, Florida, North Carolina, and Tennessee. If you're buying in one of these four states, the Boots-First Benefit Review is built for you." },
];

export const BOOKING_TRUST = [
  "Free — no cost to attend",
  "No obligation, no application required",
  "Written next step, whatever the timing",
  "Live sessions run twice a week",
];

export const TIMELINES = ["Buying soon (next 60 days)", "Buying in 2-6 months", "Just exploring my options"];
